import { z } from 'zod';

export const STATEMENT_MAX_LENGTH = 1000;
export const NAME_MAX_LENGTH = 50;
export const TITLE_MAX_LENGTH = 100;

export const endorsementFormSchema = z.object({
	name: z
		.string()
		.min(1, 'This is a required field')
		.max(NAME_MAX_LENGTH, `Maximum ${NAME_MAX_LENGTH} characters allowed`),
	title: z
		.string()
		.min(1, 'This is a required field')
		.max(TITLE_MAX_LENGTH, `Maximum ${TITLE_MAX_LENGTH} characters allowed`),
	statement: z.string().max(STATEMENT_MAX_LENGTH, `Maximum ${STATEMENT_MAX_LENGTH} characters allowed`).optional(),
	photoUrl: z.string().min(1, 'This is a required field'),
	url: z.url('Please enter a valid URL').min(1, 'This is a required field'),
});

export type EndorsementFormSchema = z.infer<typeof endorsementFormSchema>;
